import http, { httpmock } from '@/utils/http';
const endpoint = 'mypage';

export default {
  async  generateMyPageDate(slug_name, my_page_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const data = {
      slug_name: slug_name,
      my_page_id: my_page_id,
    };
    const response = await http.post(`${endpoint}/get-my-page`, data, config);
    return response.data;
  },
}
